angular.module('zc.commonApi')
  .filter('overallCampaignCvrIncreaseRate', () => (campaigns, includeHiddenAb) => {
    campaigns = _.filter(campaigns, campaign => (!campaign.is_secret_ab || includeHiddenAb) && !campaign.is_information_campaign && !!campaign.campaign_control_percent);

    const totalExperimentalConversionCount = _.sumBy(
      campaigns,
      'stats.experimental.conversion_count'
    );
    const weightedDenominator = _.sumBy(campaigns, campaign => {
      const experimentalDeliveryCount = _.get(campaign, 'stats.experimental.delivery_count', 0);
      const controlConversionCount = _.get(campaign, 'stats.control.conversion_count', 0);
      const controlDeliveryCount = _.get(campaign, 'stats.control.delivery_count', 0);
      const controlCVR = controlDeliveryCount === 0 ? 0 : controlConversionCount / controlDeliveryCount;
      return experimentalDeliveryCount * controlCVR;
    });

    if(weightedDenominator === 0) return null;

    return totalExperimentalConversionCount / weightedDenominator;
  });



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/filters/overall_campaign_cvr_increase_rate.js